import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
    --white: #FFFFFF;
    --black: #1E1E1E;
    --Dark_1: #716D6A;
    --Dark_2: #202124;
    --Dark_3: #3C4043;
    --Accent_1: #FECA78;
    --Accent_2: #6786B8;
    --Light: #FBF4ED;
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: var(--Dark_1);
    line-height: 1.25;
    background: var(--Light);
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body{
    overflow-y: scroll;
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Graphik', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: var(--Dark_1);
    transition: all 0.25s ease 0s;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  button { font-weight: 400; }
  /* ${mediaMax('mobileLandscape')} {
    body.landscape {
      max-height: 100%;
      overflow: hidden;
      visibility: hidden;
      background: #8c9ea3;
    }
  } */
  .home-content {
    will-change: transform; 
  }

  /* ----- Animations ----- */
  .fadeIn {
    opacity: 0;
    transition: opacity 1s;
    &.visible {
      opacity: 1;
    }
  }
  .fadeInTitleFromBottom {
    overflow: hidden;
    & > span {
      transform: translateY(110%);
      transition: transform 1s;
    }
    &.visible > span {
      transform: translateY(0);
    }
  }
  .fadeInFromBottom {
    transform: translateY(100px);
    opacity: 0;
    transition: transform 1s, opacity 1s;
    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }
  .slideInFromTop {
    opacity: 0;
    transition: opacity .25s;
    position: relative;
    &::before {
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      content: "";
      background: #fbf4ed;
      transition: all 1s;
      z-index: 5;
    }
    img {
      transform: translateY(-100px) !important;
      transition: opacity .25s linear, transform 1s !important;
    }
    &.visible {
      opacity: 1;
      &::before {
        top: 100%;
      }
      img {
        transform: translateY(0) !important;
      }
    }
  }
  .slideInFromLeft {
    opacity: 0;
    transition: opacity .25s;
    position: relative;
    &::before {
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      content: "";
      background: #fbf4ed;
      transition: left 1s;
      z-index: 5;
    }
    img {
      transform: translateX(-100px) !important;
      transition: opacity .25s linear, transform 1s !important;
    }
    &.visible {
      opacity: 1;
      &::before {
        left: 100%;
      }
      img {
        transform: translateX(0) !important;
      }
    }
  }
  .copyColsLine {
    &::before {
      right: 100% !important;
      transition: right 1s;
    }
    &.visible {
      &::before {
        right: 0 !important;
      }
    }
    ${mediaMax('mobile')} {
      &.visible {
        &::before {
          left:  ${calculateMobileResponsiveSize(20)} !important;
          right: ${calculateMobileResponsiveSize(20)} !important;
        }
      }
    }
  }
  .copy-cols-3 .copyColsLine {
    &.visible {
      &::before {
        left: 0 !important;
        right: 0 !important;
      }
    }
    ${mediaMax('mobile')} {
      &.visible {
        &::before {
          right: 0 !important;
        }
      }
    }
  }

  .residence-info .copyColsLine {
    &.visible {
      &::before {
        left: 0 !important;
        right: 0 !important;
      }
    }
    ${mediaMax('mobile')} {
      &.visible {
        &::before {
          left: ${calculateMobileResponsiveSize(20)} !important;
          right: ${calculateMobileResponsiveSize(20)} !important;
        }
      }
    }
  }

  /* ----- UserWay ----- */
  body .uwy {
    opacity: 1;
    visibility: visible;
    transition: opacity 2s, visibility 2s;
    z-index: 50 !important;
    &.hide {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0s, visibility 0s;
    }
  }
  body .uwy > .userway_buttons_wrapper  {
    top: auto !important;
    bottom: ${calculateResponsiveSize(30)} !important;
    left: ${calculateResponsiveSize(35)} !important;
    right: auto !important;
    transform: none !important;
  }
  body .uwy .uai, body .uwy .uai > span {
    width: ${calculateResponsiveSize(40)} !important;
    height: ${calculateResponsiveSize(40)} !important;
  }
  body .uwy .uai > span > img {
    width: 100% !important;
    height: auto !important;
  }
  ${mediaMax('mobile')} {
    body .uwy > .userway_buttons_wrapper  {
      bottom: ${calculateMobileResponsiveSize(9)} !important;
      left: ${calculateMobileResponsiveSize(14)} !important;
    }
    body .uwy .uai, body .uwy .uai > span {
      width: ${calculateMobileResponsiveSize(30)} !important;
      height: ${calculateMobileResponsiveSize(30)} !important;
    }
  }

  /* ----- Registered Symbol ----- */
  sup {
    font-size: 0.4em;
    position: relative;
    top: 0.3em;
    &.tm {
      font-size: 0.6em;
      top: 0;
    }
  }

  /* ----- For gallery ----- */
  .portal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 103;
    display: flex;
    justify-content: center;
  }

  /* ----- reCAPTCHA: badge hidden; attribution shown inside the form ----- */
  .grecaptcha-badge {
    visibility: hidden;
  }
`

export default GlobalStyle
